import { ExamRegistration } from "../types/types";
import { getErrorMessage, privateApiClient } from "../utils/axios.utils";

class ExamRegistrationService {
  /**
   * Fetch a single exam registration by ID.
   */
  async getExamRegistration(id: number): Promise<ExamRegistration> {
    try {
      const response = await privateApiClient.get<{
        data: ExamRegistration;
        message: string;
        success: boolean;
      }>(`/exam-registrations/${id}`);
      return response.data.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }

  /**
   * Fetch all exam registrations for the current school.
   */
  async getSchoolExamRegistrations(): Promise<ExamRegistration[]> {
    try {
      const response = await privateApiClient.get<{
        data: { data: ExamRegistration[] };
        message: string;
        success: boolean;
      }>(`/exam-registrations/school/own`);
      return response.data.data.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }
}

export default new ExamRegistrationService();
